import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3f731fa0&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=3f731fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f731fa0",
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QBtn,QSpace,QTooltip,QBadge,QDialog,QAvatar,QMenu,QCard,QList,QItem,QItemSection,QToolbarTitle,QDrawer,QScrollArea,QExpansionItem,QIcon,QItemLabel,QPageContainer,QCardSection,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QHeader,QToolbar,QBtn,QSpace,QTooltip,QBadge,QDialog,QAvatar,QMenu,QCard,QList,QItem,QItemSection,QToolbarTitle,QDrawer,QScrollArea,QExpansionItem,QIcon,QItemLabel,QPageContainer,QCardSection})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
